import { useState } from 'react';
import StyledLogEntry from './StyledLogEntry';
import HtmlRenderer from '../../utils/HtmlRenderer';
import EditButton from './EditButton';
import DeleteLogEntry from './DeleteLogEntry';
import LogEntryEditor from './LogEntryEditor';
import { type LogEntry as LogEntryType } from '@/lib/types';
import EmptyLogEntryMessage from './EmptyLogEntryMessage';
import LogEntryFiles from './LogEntryFiles';
import LogEntryCoachComments from './LogEntryCoachComments';
import CommentHeader from '@/components/comment/CommentHeader';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import CommentActionsWrapper from '@/components/comment/CommentActionsWrapper';
import CommentUser from '@/components/comment/CommentUser';

type LogEntryProps = {
  logEntry: LogEntryType;
  logEntryName: string;
};

const LogEntry = ({ logEntry, logEntryName }: LogEntryProps) => {
  const [editing, setEditing] = useState(false);

  const logEntryHasContent = logEntry.content.trim().length > 0;
  const logEntryHasImages = Object.keys(logEntry.images).length > 0;
  const logEntryHasExternalFiles =
    Object.keys(logEntry.externalFiles).length > 0;

  return (
    <StyledLogEntry className="log-entry">
      <CommentHeader>
        <CommentUser user={logEntry.author} createdAt={logEntry.createdAt} />
        {!editing && (
          <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
            <CommentActionsWrapper>
              <EditButton onClick={() => setEditing(true)} />
              <DeleteLogEntry logEntry={logEntry} />
            </CommentActionsWrapper>
          </RestrictedToPortfolioMode>
        )}
      </CommentHeader>
      {!editing &&
        !logEntryHasContent &&
        !logEntryHasImages &&
        !logEntryHasExternalFiles && (
          <EmptyLogEntryMessage logEntryName={logEntryName} />
        )}
      {editing && (
        <LogEntryEditor logEntry={logEntry} onClose={() => setEditing(false)} />
      )}
      {!editing && logEntryHasContent && (
        <HtmlRenderer source={logEntry.content} darkText />
      )}
      {(editing || logEntryHasImages || logEntryHasExternalFiles) && (
        <LogEntryFiles logEntry={logEntry} />
      )}
      <LogEntryCoachComments logEntry={logEntry} />
    </StyledLogEntry>
  );
};

export default LogEntry;
